import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import InstallmentPreviewWidgetProxy from "../InstallmentPreviewWidget/InstallmentPreviewWidgetProxy";

const InstallmentPreviewWidgetPortal = (props) => {

    const {
        el,
        data
    } = props;

    return ReactDOM.createPortal(
        <InstallmentPreviewWidgetProxy
            data={data}
        />, el
    );

}

InstallmentPreviewWidgetPortal.propTypes = {
    el: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired
}

export default InstallmentPreviewWidgetPortal;